var g = (r) => {
  throw TypeError(r);
};
var L = (r, t, e) => t.has(r) || g("Cannot " + e);
var b = (r, t, e) => t.has(r) ? g("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(r) : t.set(r, e);
var i = (r, t, e) => (L(r, t, "access private method"), e);
let u = /* @__PURE__ */ new WeakMap();
const B = new Event("scrollend"), p = /* @__PURE__ */ new Set();
function o(r, t, e) {
  let l = r[t];
  r[t] = function() {
    let a = Array.prototype.slice.apply(arguments, [0]);
    l.apply(this, a), a.unshift(l), e.apply(this, a);
  };
}
function E(r, t) {
  if (t !== "scroll" && t !== "scrollend")
    return;
  let e = u.get(this);
  if (e === void 0) {
    let l = 0;
    e = {
      scrollListener: () => {
        clearTimeout(l), l = setTimeout(() => {
          p.size ? setTimeout(e.scrollListener, 100) : (this.dispatchEvent(B), l = 0);
        }, 100);
      },
      listeners: 0
      // Count of number of listeners.
    }, r.apply(this, ["scroll", e.scrollListener]), u.set(this, e);
  }
  e.listeners++;
}
function m(r, t) {
  if (t !== "scroll" && t !== "scrollend") return;
  let e = u.get(this);
  e !== void 0 && (e[t]--, !(--e.listeners > 0) && (r.apply(this, ["scroll", e.scrollListener]), u.delete(this)));
}
const z = "onscrollend" in window;
var s, d, x, A, w, h, c, y, I, T;
class P {
  constructor({ carouselEl: t, scrollerEl: e, paginationEl: l, slides: a, navBtnEls: S = { next: {}, previous: {} }, options: n }) {
    b(this, s);
    z || (document.addEventListener("touchstart", (f) => {
      for (let v of f.changedTouches)
        p.add(v.identifier);
    }, { passive: !0 }), document.addEventListener("touchend", (f) => {
      for (let v of f.changedTouches)
        p.delete(v.identifier);
    }, { passive: !0 }), o(Element.prototype, "addEventListener", E), o(window, "addEventListener", E), o(document, "addEventListener", E), o(Element.prototype, "removeEventListener", m), o(window, "removeEventListener", m), o(document, "removeEventListener", m)), this.carouselEl = t, this.scrollerEl = e, this.paginationEl = l, this.slides = a, this.currentIndex = 0, this.slideEls = [...e.children], this.navBtnEls = S, this.currentIntersecting = {}, this.options = n, n.autoplay && (this.timer = null, this.timerInterval = (n == null ? void 0 : n.delay) ?? 3500, this.startTimer()), this.slideGutterSize = (n == null ? void 0 : n.slideGutterSize) ?? 25, this.showPagination = n == null ? void 0 : n.showPagination, this.isInitialScroll = !0, this.totalSlideEls = this.slideEls.length, this.totalSlides = Math.ceil(this.slides.length / this.options.cellsPerSlide), i(this, s, x).call(this), i(this, s, w).call(this), i(this, s, A).call(this);
  }
  /**
   * starts the autoplay timer
   */
  startTimer() {
    this.timer || (this.timer = setInterval(() => {
      this.determineScrollAction(1);
    }, this.timerInterval));
  }
  /**
   * clears the autoplay timer
   */
  clearTimer() {
    clearInterval(this.timer), this.timer = null;
  }
  /**
   * checks to see if the scroller is moving to the
   * end or beginning, if so it makes the appropriate 
   * updates
   * 
   * @param {number} dir - a number representing the direction of scroll 1 for forward, -1 for backward
   */
  determineScrollAction(t) {
    this.options.autoplay && this.timer !== null && this.clearTimer(), t === 1 ? this.currentIndex === this.totalSlides - 1 ? this.options.wrapAround && (this.scrollerEl.style.scrollBehavior = "auto", this.scrollerEl.scrollTo(0, 0), i(this, s, h).call(this, t), this.currentIndex = 0) : (i(this, s, h).call(this, t), this.currentIndex += 1) : t === -1 && (this.currentIndex === 0 ? this.options.wrapAround && (this.scrollerEl.style.scrollBehavior = "auto", this.scrollerEl.scrollTo(99999, 0), this.currentIndex = this.totalSlides - 1, i(this, s, h).call(this, t)) : (i(this, s, h).call(this, t), this.currentIndex -= 1)), this.options.autoplay && this.timer === null && this.startTimer();
  }
  /**
   * Navigates the carousel to a specific index
   * 
   * @param {number} index 
   * @returns void
   */
  navigateToIndex(t) {
    if (t === this.currentIndex) return;
    this.options.autoplay && this.clearTimer();
    let e = t > this.currentIndex ? t - this.currentIndex : this.currentIndex - t, l = t > this.currentIndex ? 1 : -1;
    this.currentIndex = t, i(this, s, h).call(this, l, e), this.options.autoplay && this.startTimer(), i(this, s, c).call(this);
  }
  /**
   * Returns the current index of the carousel
   * 
   * @returns {number} - the current index of the carousel
   */
  getCurrentIndex() {
    return this.currentIndex;
  }
  /**
   * Handles the scrollend event - determines which slide is in view and updates the carousel
   * @returns void
   */
  handleScrollEnd() {
    if (this.timer === null && this.options.autoplay && this.startTimer(), this.currentIntersecting.target) {
      const t = Number.parseInt(this.currentIntersecting.target.getAttribute("data-index"), 10);
      if (!this.options.wrapAround) {
        this.currentIndex = t, i(this, s, c).call(this);
        return;
      }
      t === 0 ? (this.currentIndex = this.slides.length - 1, i(this, s, d).call(this, { scrollport: this.scrollerEl, element: this.slideEls[this.totalSlides] })) : t === this.totalSlideEls - 1 ? (this.currentIndex = 0, i(this, s, d).call(this, { scrollport: this.scrollerEl, element: this.slideEls[1] })) : this.currentIndex = t - 1;
    }
    i(this, s, c).call(this);
  }
}
s = new WeakSet(), /**
 * Scrolls the carousel to a specific child element
 * @param {*} param0 - an object containing the scrollport element and the child element to scroll to 
 */
d = function({ scrollport: t, element: e }) {
  const l = this.slideGutterSize * 2 / 100;
  t.style.scrollBehavior = "auto", t.scrollTo(Math.abs(t.offsetLeft - e.offsetLeft + e.clientWidth * l), 0);
}, /**
 * adds an observer to the scroller element that we can use to 
 * determine which slide is intersecting
 */
x = function() {
  this.carouselObserver = new IntersectionObserver((t) => {
    for (let e of t)
      e.isIntersecting && (this.currentIntersecting = e);
  }, {
    root: this.scrollerEl,
    threshold: 0.8
  });
}, /**
 * sets listeners on the slide elements for the observer
 */
A = function() {
  for (let t of this.slideEls)
    this.carouselObserver.observe(t);
}, /**
 * sets some intial settings for the carousel based on some of the options
 */
w = function() {
  this.options.wrapAround ? (this.scrollerEl.style.scrollBehavior = "auto", this.scrollerEl.scrollTo(-9999, 0), i(this, s, d).call(this, { scrollport: this.scrollerEl, element: this.scrollerEl.children[1] })) : this.options.showControls ? (this.navBtnEls.previous.setAttribute("disabled", !0), i(this, s, c).call(this)) : i(this, s, I).call(this), this.totalSlides === 1 && this.slideEls[0].removeAttribute("inert");
}, /**
 * Scrolls the carousel in a specified direction by a specified distance
 * 
 * @param {number} dir - a number representing the direction of scroll 1 for forward, -1 for backward 
 * @param {number} distance - a number representing the number of slides to scroll
 */
h = function(t, e = 1) {
  this.scrollerEl.style.scrollBehavior = "smooth", this.scrollerEl.scrollBy({
    left: this.scrollerEl.clientWidth * ((100 - this.slideGutterSize * 2) / 100) * e * t,
    top: 0,
    behavior: "smooth"
  });
}, /**
 * Syncronizes various elements of the carousel
 * 
 * add methods here to have them sync 
 * when scroller is scrolled
 */
c = function() {
  i(this, s, I).call(this), this.showPagination && i(this, s, T).call(this), this.options.wrapAround || i(this, s, y).call(this);
}, /**
 * Sets the control arrow buttons to disabled if the carousel is at the start or end
 */
y = function() {
  this.navBtnEls.previous && this.navBtnEls.next && (this.navBtnEls.previous.removeAttribute("disabled"), this.navBtnEls.next.removeAttribute("disabled"), this.currentIndex === 0 && this.navBtnEls.previous.toggleAttribute("disabled"), this.currentIndex === this.slideEls.length - 1 && this.navBtnEls.next.toggleAttribute("disabled"));
}, /**
 * Sets the inert attribute on all slides that are not the current slide
 */
I = function() {
  const t = this.options.wrapAround ? this.currentIndex + 1 : this.currentIndex;
  this.slideEls.length === 1 ? this.slideEls[0].removeAttribute("inert") : this.slideEls.forEach((e, l) => {
    e.toggleAttribute("inert", l !== t);
  });
}, /**
 * Sets the pagination indicator to the current slide
 */
T = function() {
  [...this.paginationEl.children].forEach((t, e) => {
    e === this.currentIndex ? t.setAttribute("data-current", "true") : t.setAttribute("data-current", "false");
  });
};
export {
  P as default
};
